import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { Regulation } from '@/types/sez-regions'
import { formatFileSize } from '@/utils/formatter'

interface RegulationCardProps {
  regulation: Regulation
}

const RegulationCard: React.FC<RegulationCardProps> = ({ regulation }) => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col items-center gap-4 rounded-lg border border-neutral-border px-3.5 py-3 transition-all duration-300 lg:flex-row lg:hover:border-red lg:hover:shadow-flay'>
      <div className='flex w-full items-center gap-4'>
        <div className='flex h-19 w-19 basis-19 flex-col rounded-lg bg-neutral-disable'>
          <div className='flex h-full items-center justify-center'>
            <span className='kek-pdf text-[28px] text-red' />
          </div>

          <div className='flex h-fit w-full justify-center rounded-b-lg bg-yellow px-1.5 py-1'>
            <span className='text-xxs font-medium text-dark'>{formatFileSize(regulation.file.fileSize ?? 0)}</span>
          </div>
        </div>

        <div className='flex flex-1 flex-col gap-1 lg:gap-3'>
          <p className='text-sm font-semibold tracking-[-0.084px] text-gray-1 lg:text-base lg:font-medium lg:tracking-[-0.176px]'>
            {regulation.title}
          </p>
          <small className='text-xs font-semibold text-gray-2'>{regulation.description}</small>
        </div>
      </div>

      <Link
        href={regulation.file.url || ''}
        className='group flex w-full items-center justify-center gap-2 rounded-full bg-orange/10 px-5 py-3 transition-all duration-300 lg:w-fit lg:hover:bg-red'
        download
        target='_blank'
      >
        <span className='font-work font-bold text-red transition-all duration-300 lg:group-hover:text-white'>
          {t('common:download')}
        </span>
        <span className='kek-arrow-download text-xl text-red transition-all duration-300 lg:group-hover:text-white' />
      </Link>
    </div>
  )
}

export default RegulationCard
